import React from 'react';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input, CheckboxCustom } from 'components';
import { useModal } from 'utils';
import { formModelEnums } from '../../constants';
import { SECTION_NAME_MAX_LENGTH } from './sectionSettings.constants';

export const CreateSection = ({ onCreateSection, formList }) => {
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            sessionName: '',
            goalSection: false,
        },
    });
    const { close } = useModal();

    const handleCreate = (data) => {
        onCreateSection?.(data.sessionName.trim(), data.goalSection);
        close();
    };

    return (
        <div style={{ width: 560 }}>
            <div className="modal-section-padding" style={{ borderBottom: '1px solid #DFE1E6' }}>
                <p className="modal-header-title">Create New Section</p>
                <p className="modal-box-title" style={{ color: '#475467', fontWeight: 400 }}>
                    Add a new section to organize your form fields.
                </p>
            </div>

            <form onSubmit={handleSubmit(handleCreate)}>
                <div className="modal-section-padding" style={{ paddingBottom: 0 }}>
                    <Input
                        name="sessionName"
                        label="Section Name *"
                        variant="outlined"
                        control={control}
                        maxLength={SECTION_NAME_MAX_LENGTH}
                        rules={{
                            maxLength: {
                                value: SECTION_NAME_MAX_LENGTH,
                                message: `Max length is ${SECTION_NAME_MAX_LENGTH} characters.`,
                            },
                            required: 'Section name is required.',
                            validate: (value) => !!value?.trim() || 'Section name is required.',
                        }}
                        helperText={'You can add fields to this section after creating it'}
                    />
                    {formList?.model === formModelEnums.PROGRESSREPORT && (
                        <div>
                            <CheckboxCustom control={control} name="goalSection" label="Goal Section" padding={'0 9px 0 0'} />
                        </div>
                    )}
                </div>

                <div className="modal-section-padding">
                    <CreateChancel
                        type="submit"
                        create={'Save'}
                        chancel={'Cancel'}
                        onClose={close}
                        buttonWidth="100%"
                        cancelButtonWidth="100%"
                    />
                </div>
            </form>
        </div>
    );
};
